export default {
  GET_DRVIERS: '@MY_DRIVERS/GET_DRVIERS',
  GET_DRVIERS_SUCCESS: '@MY_DRIVERS/GET_DRVIERS_SUCCESS',
  GET_DRVIERS_FAILURE: '@MY_DRIVERS/GET_DRVIERS_FAILURE',
  CLEAR_DRVIERS: '@MY_DRIVERS/CLEAR_DRVIERS',
  LOAD_MORE: '@MY_DRIVERS/LOAD_MORE',
  SET_FILTERS: '@MY_DRIVERS/SET_FILTERS',

  SET_DRVIERS: '@MY_DRIVERS/SET_DRVIERS',
  SET_DRVIERS_SUCCESS: '@MY_DRIVERS/SET_DRVIERS_SUCCESS',
  SET_DRVIERS_FAILURE: '@MY_DRIVERS/SET_DRVIERS_FAILURE',

  DELETE_DRVIERS: '@MY_DRIVERS/DELETE_DRVIERS',
  DELETE_DRVIERS_SUCCESS: '@MY_DRIVERS/DELETE_DRVIERS_SUCCESS',
  DELETE_DRVIERS_FAILURE: '@MY_DRIVERS/DELETE_DRVIERS_FAILURE'
}
